import React from 'react';
import styled from 'styled-components';

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="card">
        <div className="loader">
          <div className="words">
            <span className="word">Sineklik</span>
            <span className="word">Duşakabin</span>
            <span className="word">Cam&nbsp;Balkon</span>
            <span className="word">Panjur</span>
            <span className="word">Pencere</span>
            <span className="word">Kapı</span>
          </div>
          <p>Sistemlerinde Güvenilir ve Uygun Çözümler</p>
        </div>
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .card {
    padding: 1rem 2rem;

    @media (max-width: 768px) {
      padding: 0.5rem 1rem;
    }
  }

  .loader {
    color: #ffffff;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 40px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 55px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 8px;

    @media (max-width: 768px) {
      font-size: 24px;
      height: auto;
      flex-direction: column;
      align-items: center;
    }
  }

  p {
    margin-top: 0px;
    margin-left: 15px;
    color: white;

    @media (max-width: 768px) {
      margin-left: 0;
      margin-top: 10px;
      font-size: 17px;
      text-align: center;
    }
  }

  .words {
    overflow: hidden;
    text-align: end;
    width: 365px;
    color: white;
    height: 60px;
    position: relative;

    @media (max-width: 768px) {
      width: 250px;
      height: 45px;
      text-align: center;
    }
  }

  .words::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 20;
  }

  .word {
    display: block;
    height: 100%;
    color: #D40D12;
    animation: spin_4991 15s infinite;
  }

  @keyframes spin_4991 {
    10% {
      -webkit-transform: translateY(-102%);
      transform: translateY(-102%);
    }

    25% {
      -webkit-transform: translateY(-100%);
      transform: translateY(-100%);
    }

    35% {
      -webkit-transform: translateY(-202%);
      transform: translateY(-202%);
    }

    50% {
      -webkit-transform: translateY(-200%);
      transform: translateY(-200%);
    }

    60% {
      -webkit-transform: translateY(-302%);
      transform: translateY(-302%);
    }

    75% {
      -webkit-transform: translateY(-300%);
      transform: translateY(-300%);
    }

    85% {
      -webkit-transform: translateY(-402%);
      transform: translateY(-402%);
    }

    100% {
      -webkit-transform: translateY(-400%);
      transform: translateY(-400%);
    }
  }
`;

export default Loader;